module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-sm-12"
  }, [_c('text-group', {
    attrs: {
      "label": "会社名",
      "val": _vm.company.name
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }, [_c('div', {
    attrs: {
      "slot": "line"
    },
    slot: "line"
  })]), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": ""
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.searchCompany
    }
  }, [_vm._v("企業データ検索")]), _vm._v(" "), _c('corporate-row', {
    attrs: {
      "corporates": _vm.corporates
    },
    on: {
      "activate": _vm.activate
    }
  })], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "法人番号",
      "val": _vm.company.corporate_number
    },
    model: {
      value: (_vm.company.corporate_number),
      callback: function($$v) {
        _vm.$set(_vm.company, "corporate_number", $$v)
      },
      expression: "company.corporate_number"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "会社名_かな",
      "val": _vm.company.name_kana
    },
    model: {
      value: (_vm.company.name_kana),
      callback: function($$v) {
        _vm.$set(_vm.company, "name_kana", $$v)
      },
      expression: "company.name_kana"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "上場区分"
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.stock_type),
      expression: "company.stock_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.company, "stock_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "未上場"
    }
  }, [_vm._v("未上場")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "東証一部"
    }
  }, [_vm._v("東証一部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "東証二部"
    }
  }, [_vm._v("東証二部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "JASDAQ"
    }
  }, [_vm._v("JASDAQ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "東証マザーズ"
    }
  }, [_vm._v("東証マザーズ")])])])], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "会社URL",
      "val": _vm.company.corporate_url
    },
    model: {
      value: (_vm.company.corporate_url),
      callback: function($$v) {
        _vm.$set(_vm.company, "corporate_url", $$v)
      },
      expression: "company.corporate_url"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": ""
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.google.com/search?q=" + (_vm.company.name)),
      "target": "_blank"
    }
  }, [_vm._v("Google検索")])])], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "登記日",
      "val": _vm.company.registration_at
    },
    model: {
      value: (_vm.company.registration_at),
      callback: function($$v) {
        _vm.$set(_vm.company, "registration_at", $$v)
      },
      expression: "company.registration_at"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "郵便番号",
      "val": _vm.company.zip
    },
    model: {
      value: (_vm.company.zip),
      callback: function($$v) {
        _vm.$set(_vm.company, "zip", $$v)
      },
      expression: "company.zip"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "住所",
      "val": _vm.company.address
    },
    model: {
      value: (_vm.company.address),
      callback: function($$v) {
        _vm.$set(_vm.company, "address", $$v)
      },
      expression: "company.address"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "資本金",
      "val": _vm.company.capital
    },
    model: {
      value: (_vm.company.capital),
      callback: function($$v) {
        _vm.$set(_vm.company, "capital", $$v)
      },
      expression: "company.capital"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "代表取締役",
      "val": _vm.company.ceo
    },
    model: {
      value: (_vm.company.ceo),
      callback: function($$v) {
        _vm.$set(_vm.company, "ceo", $$v)
      },
      expression: "company.ceo"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "従業員数",
      "val": _vm.company.employer_count
    },
    model: {
      value: (_vm.company.employer_count),
      callback: function($$v) {
        _vm.$set(_vm.company, "employer_count", $$v)
      },
      expression: "company.employer_count"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "企業紹介_タイトル",
      "val": _vm.company.strength_title
    },
    model: {
      value: (_vm.company.strength_title),
      callback: function($$v) {
        _vm.$set(_vm.company, "strength_title", $$v)
      },
      expression: "company.strength_title"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": "企業紹介_詳細"
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.strength_detail),
      expression: "company.strength_detail"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.company.strength_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "strength_detail", $event.target.value)
      }
    }
  })])], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.updateCompany
    }
  }, [_vm._v("更新")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53bf5b58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Form.vue
// module id = 456
// module chunks = 1